/* Favre — strona „Kundenbewertungen” (sections/favre-bewertungen-seite.liquid, 2026-10-26).
   Opinie z Judge.me: 1. strona z metapola (od razu), potem wszystkie strony publicznego API (HTML, 25/str.),
   filtr gwiazdek / modelu / „Mit Fotos” i sortowanie liczone w przeglądarce. Wygląd kart = karta produktu (favre-bewertungen). */
(() => {
  const init = (root) => {
    if (root.__fbs) return;
    root.__fbs = true;
    const $ = (s) => root.querySelector(s);
    const L = root.dataset;
    const lang = (document.documentElement.lang || 'de').slice(0, 2);
    const nf = new Intl.NumberFormat(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const ILE = Number(L.ile) || 0;
    const SREDNIA = Number(L.srednia) || 0;
    const PIERWSZE = 10, PORCJA = 10, NA_STRONE = 25;
    const lista = $('[data-fbs-list]');
    const wiecej = $('[data-fbs-show-more]');
    const status = $('[data-fbs-status]');
    let laduje = true; // Promise pobierania wszystkich stron API (null = gotowe)

    const GW = 'M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9l-5.2 2.8 1-5.9L1.5 7.7l5.9-.8z';
    const gwiazdki = (ocena) => {
      let h = '';
      for (let i = 1; i <= 5; i++) {
        const fill = Math.max(0, Math.min(1, ocena - i + 1));
        h += `<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path class="fbs__star-bg" d="${GW}"/><path class="fbs__star" style="clip-path: inset(0 ${Math.round((1 - fill) * 100)}% 0 0)" d="${GW}"/></svg>`;
      }
      return h;
    };
    const tekst = (s) => { const d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
    const liczba = (n) => (n === 1 ? L.lCountOne : L.lCount.replace('§', n));

    // ---------- linie (do filtra modeli): handle produktu → nazwa linii ----------
    let linie = [];
    try { linie = JSON.parse($('[data-fbs-linien]')?.textContent || '[]'); } catch (e) {}
    const liniaHandle = new Map();
    linie.forEach((l) => l.h.forEach((h) => liniaHandle.set(h, l.t)));
    const liniaOpinii = (r) => {
      const h = (r.prodUrl.split('/products/')[1] || '').split(/[?#]/)[0];
      if (liniaHandle.has(h)) return liniaHandle.get(h);
      // stary adres produktu (zmiana handle 2026-10-23) → po nazwie z tytułu
      const t = (r.prodTitle || '').toLowerCase();
      const l = linie.slice().sort((a, b) => b.t.length - a.t.length).find((x) => t.includes(x.t.toLowerCase()));
      return l ? l.t : '';
    };

    // ---------- opinia z HTML Judge.me ----------
    const IMPORT_DO = Date.parse('2026-10-17T00:00:00Z');
    const czytaj = (el, sklep) => {
      const q = (s) => el.querySelector(s);
      const body = q('.jdgm-rev__body');
      const prod = q('.jdgm-rev__prod-link');
      const autor = (q('.jdgm-rev__author')?.textContent || '').trim();
      const r = {
        id: el.dataset.reviewId || '',
        rating: Number(q('.jdgm-rev__rating')?.dataset.score) || 0,
        verified: el.dataset.verifiedBuyer === 'true',
        created: Date.parse((q('.jdgm-rev__timestamp')?.dataset.content || '').replace(' UTC', 'Z').replace(' ', 'T')),
        title: (q('.jdgm-rev__title')?.textContent || '').trim(),
        body: body ? [...body.querySelectorAll('p')].map((p) => p.textContent.trim()).filter(Boolean).join('\n') || body.textContent.trim() : '',
        autor: !autor || /^anonymous$/i.test(autor) ? L.lAnon : autor,
        prodUrl: prod?.getAttribute('href') || '',
        prodTitle: (prod?.textContent || '').trim(),
        pics: [...el.querySelectorAll('.jdgm-rev__pic-link')].map((a) => (a.getAttribute('href') || a.dataset.mfpSrc || '').split('?')[0]).filter((u) => u && !(window.favreFotoBlok || []).some((k) => u.includes(k))),
        reply: (q('.jdgm-rev__reply')?.textContent || '').replace(/\s+/g, ' ').trim(),
        sklep: !!sklep,
      };
      r.linia = r.sklep ? '' : liniaOpinii(r);
      return r;
    };
    const foto = (u, w) => `${u}?quality=82&width=${w}`;
    const znaczek = (r, tag) => {
      if (r.verified) return `<${tag} class="fbs__ver">${tekst(L.lVerified)}</${tag}>`;
      if (!isNaN(r.created) && r.created < IMPORT_DO) return `<${tag} class="fbs__ver">${tekst(L.lPartner)}</${tag}>`;
      return '';
    };

    // ---------- magazyn opinii ----------
    const wszystkie = []; // kolejność = najnowsze (jak API)
    const ids = new Set();
    const przyjmij = (html, sklep) => {
      if (!html) return 0;
      const doc = new DOMParser().parseFromString(`<div>${html}</div>`, 'text/html');
      let n = 0;
      doc.querySelectorAll('.jdgm-rev').forEach((el) => {
        const r = czytaj(el, sklep);
        if (!r.id || ids.has(r.id)) return;
        ids.add(r.id);
        r.nr = wszystkie.length;
        wszystkie.push(r);
        n++;
      });
      return n;
    };

    // ---------- podsumowanie (średnia, poleca, rozkład) ----------
    const wynik = () => {
      let r = Math.round(SREDNIA * 10) / 10;
      if (r >= 5 && SREDNIA < 5) r = 4.9;
      return r;
    };
    $('[data-fbs-avg]').textContent = ILE ? nf.format(wynik()) : '–';
    $('[data-fbs-stars-big]').innerHTML = gwiazdki(SREDNIA);
    $('[data-fbs-count]').textContent = liczba(ILE);
    // rozkład: z nagłówka Judge.me (metapole), po pobraniu wszystkich — przeliczony z opinii
    let rozklad = [5, 4, 3, 2, 1].map((s) => ({ s, n: 0 }));
    const kopf = $('[data-fbs-kopf]');
    if (kopf) {
      kopf.content.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach((row) => {
        const s = Number(row.dataset.rating);
        const x = rozklad.find((y) => y.s === s);
        if (x) x.n = Number(row.dataset.frequency) || 0;
      });
    }
    const hist = $('[data-fbs-hist]');
    const rec = $('[data-fbs-rec]');
    const rysujRozklad = () => {
      const suma = rozklad.reduce((a, x) => a + x.n, 0);
      if (!suma) return;
      const polec = rozklad.filter((x) => x.s >= 4).reduce((a, x) => a + x.n, 0);
      rec.textContent = L.lRecommend.replace('[x]', polec).replace('[y]', suma).replace('[p]', Math.round((polec / suma) * 100));
      rec.hidden = false;
      hist.innerHTML = rozklad.map((x) => `<li><button type="button" class="fbs__hist-row${filtr.gw === x.s ? ' is-active' : ''}" data-gw="${x.s}" aria-pressed="${filtr.gw === x.s}" ${x.n ? '' : 'disabled'} aria-label="${tekst(L.lStars.replace('§', x.s))}: ${x.n}"><span class="fbs__hist-n">${x.s}</span><svg viewBox="0 0 20 20" aria-hidden="true"><path class="fbs__star" d="${GW}"/></svg><span class="fbs__hist-bar"><span style="width:${Math.round((x.n / suma) * 100)}%"></span></span><span class="fbs__hist-c">${x.n}</span></button></li>`).join('');
      hist.hidden = false;
    };

    // ---------- filtr + lista ----------
    const filtr = { gw: null, linia: '', sklep: false, fotos: false, sort: 'neu' };
    let wynikFiltra = [];
    let pokazane = 0;
    const filtruj = () => {
      const l = wszystkie.filter((r) => (!filtr.gw || r.rating === filtr.gw) && (!filtr.linia || r.linia === filtr.linia) && (!filtr.sklep || r.sklep) && (!filtr.fotos || r.pics.length));
      const cmp = {
        neu: (a, b) => a.nr - b.nr,
        fotos: (a, b) => (b.pics.length > 0) - (a.pics.length > 0) || a.nr - b.nr,
        beste: (a, b) => b.rating - a.rating || (b.pics.length > 0) - (a.pics.length > 0) || a.nr - b.nr,
        kritisch: (a, b) => a.rating - b.rating || a.nr - b.nr,
      }[filtr.sort];
      return l.sort(cmp);
    };
    const opinia = (r) => {
      const miniatury = r.pics.length
        ? `<div class="fbs__thumbs">${r.pics.map((u, i) => `<button type="button" class="fbs__thumb" data-fbs-lb="${tekst(r.id)}" data-i="${i}" aria-label="${tekst(r.autor)}"><img src="${foto(u, 240)}" alt="" loading="lazy" width="96" height="96"></button>`).join('')}</div>`
        : '';
      const produkt = r.sklep
        ? `<p class="fbs__prodlink">${tekst(L.lShop)}</p>`
        : r.prodUrl ? `<a class="fbs__prodlink" href="${tekst(r.prodUrl)}">${tekst(r.prodTitle)}</a>` : '';
      return `<div class="fbs__item" role="listitem">
        <div class="fbs__who">
          <p class="fbs__name">${tekst(r.autor)}</p>
          ${znaczek(r, 'p')}
          <div class="fbs__stars" role="img" aria-label="${tekst(L.lStars.replace('§', r.rating))}">${gwiazdki(r.rating)}</div>
        </div>
        <div class="fbs__content">
          ${r.title ? `<h3 class="fbs__title">${tekst(r.title)}</h3>` : ''}
          <p class="fbs__body" data-fbs-body>${tekst(r.body)}</p>
          <button type="button" class="fbs__more" data-fbs-more hidden>${tekst(L.lMore)}</button>
          ${miniatury}
          ${r.reply ? `<p class="fbs__reply"><strong>${tekst(L.lReply)}</strong> ${tekst(r.reply.replace(/^[^:]{0,40}:\s*/, ''))}</p>` : ''}
          ${produkt}
        </div>
      </div>`;
    };
    const dopiszDo = (n) => {
      const nowe = wynikFiltra.slice(pokazane, n);
      if (nowe.length) lista.insertAdjacentHTML('beforeend', nowe.map(opinia).join(''));
      pokazane = Math.max(pokazane, Math.min(n, wynikFiltra.length));
      lista.querySelectorAll('.fbs__item:not([data-ok])').forEach((k) => {
        k.dataset.ok = '';
        const b = k.querySelector('[data-fbs-body]');
        const more = k.querySelector('[data-fbs-more]');
        if (b.scrollHeight > b.clientHeight + 2) more.hidden = false;
      });
      wiecej.hidden = pokazane >= wynikFiltra.length && !(laduje && !filtrowane() && pokazane < ILE);
    };
    const filtrowane = () => filtr.gw || filtr.linia || filtr.sklep || filtr.fotos || filtr.sort !== 'neu';
    const rysuj = (zachowaj) => {
      const ile = zachowaj ? Math.max(pokazane, PIERWSZE) : PIERWSZE;
      wynikFiltra = filtruj();
      lista.innerHTML = '';
      pokazane = 0;
      dopiszDo(ile);
      const pusto = !wynikFiltra.length && !laduje;
      lista.hidden = !wynikFiltra.length;
      const n = filtrowane() || !laduje ? wynikFiltra.length : ILE;
      status.textContent = pusto ? L.lNone : liczba(n);
    };
    lista.addEventListener('click', (e) => {
      const more = e.target.closest('[data-fbs-more]');
      if (!more) return;
      const k = more.closest('.fbs__item');
      const otwarta = k.classList.toggle('is-open');
      more.textContent = otwarta ? L.lLess : L.lMore;
    });
    wiecej.addEventListener('click', async () => {
      // bez filtra: lista może iść przed pobraniem wszystkiego — poczekaj na następną porcję
      if (pokazane + PORCJA > wynikFiltra.length && laduje) {
        wiecej.classList.add('is-loading');
        await laduje;
        wiecej.classList.remove('is-loading');
        wynikFiltra = filtruj();
      }
      dopiszDo(pokazane + PORCJA);
    });

    // filtry
    const chipy = $('[data-fbs-lines]');
    const rysujChipy = () => {
      const jest = new Set(wszystkie.map((r) => r.linia).filter(Boolean));
      const sklepowe = wszystkie.some((r) => r.sklep);
      const wzor = chipy.querySelector('[data-line=""]');
      chipy.querySelectorAll('[data-line]:not([data-line=""])').forEach((b) => b.remove());
      linie.filter((l) => jest.has(l.t)).forEach((l) => {
        const b = wzor.cloneNode(false);
        b.dataset.line = l.t;
        b.textContent = l.t;
        chipy.appendChild(b);
      });
      if (sklepowe) {
        const b = wzor.cloneNode(false);
        b.dataset.line = '__sklep';
        b.textContent = L.lShop;
        chipy.appendChild(b);
      }
      chipy.querySelectorAll('[data-line]').forEach((b) => {
        const on = b.dataset.line === (filtr.linia === '' && filtr.sklep ? '__sklep' : filtr.linia);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on);
      });
    };
    chipy.addEventListener('click', (e) => {
      const b = e.target.closest('[data-line]');
      if (!b) return;
      filtr.linia = b.dataset.line === '__sklep' ? '' : b.dataset.line;
      filtr.sklep = b.dataset.line === '__sklep';
      rysujChipy();
      rysuj();
    });
    const mitFotos = $('[data-fbs-mitfotos]');
    mitFotos.addEventListener('click', () => {
      filtr.fotos = !filtr.fotos;
      mitFotos.classList.toggle('is-active', filtr.fotos);
      mitFotos.setAttribute('aria-pressed', filtr.fotos);
      rysuj();
    });
    $('[data-fbs-sort]').addEventListener('change', (e) => {
      filtr.sort = e.target.value;
      rysuj();
    });
    hist.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gw]');
      if (!b) return;
      const s = Number(b.dataset.gw);
      filtr.gw = filtr.gw === s ? null : s;
      rysujRozklad();
      rysuj();
      lista.closest('.fbs__main').querySelector('.fbs__bar').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // ---------- zdjęcia klientów ----------
    const zdjecia = () => {
      const out = [];
      wszystkie.forEach((r) => r.pics.forEach((u, i) => out.push({ r, u, i })));
      return out;
    };
    const siatka = $('[data-fbs-fotos-grid]');
    const rysujZdjecia = () => {
      const z = zdjecia();
      if (!z.length) return;
      const N = window.matchMedia('(max-width: 749px)').matches ? 8 : 12;
      siatka.innerHTML = z.slice(0, N).map((x, k) => {
        const reszta = k === N - 1 && z.length > N ? `<span class="fbs__fotos-more">+${z.length - N + 1}</span>` : '';
        return `<button type="button" class="fbs__fotos-item" data-fbs-lb="${tekst(x.r.id)}" data-i="${x.i}" aria-label="${tekst(x.r.autor)}"><img src="${foto(x.u, 300)}" alt="" loading="lazy" width="150" height="150">${reszta}</button>`;
      }).join('');
      $('[data-fbs-fotos]').hidden = false;
    };

    // ---------- podgląd zdjęcia ----------
    let lb = null, lbI = 0, lbLista = [], lbWroc = null;
    const lbPokaz = (i) => {
      if (!lbLista.length) return;
      lbI = (i + lbLista.length) % lbLista.length;
      const { r, u } = lbLista[lbI];
      const img = lb.querySelector('.fbs-lb__img');
      img.classList.remove('is-ready');
      img.onload = () => img.classList.add('is-ready');
      img.src = foto(u, 1280);
      lb.querySelector('.fbs-lb__stars').innerHTML = gwiazdki(r.rating);
      const t = lb.querySelector('.fbs-lb__title');
      t.textContent = r.title;
      t.hidden = !r.title;
      lb.querySelector('.fbs-lb__body').textContent = r.body;
      lb.querySelector('.fbs-lb__who').innerHTML = `<span class="fbs__name">${tekst(r.autor)}</span>${znaczek(r, 'span')}`;
      const p = lb.querySelector('.fbs-lb__prod');
      p.innerHTML = r.prodUrl && !r.sklep ? `<a href="${tekst(r.prodUrl)}">${tekst(r.prodTitle)}</a>` : '';
      lb.querySelector('.fbs-lb__n').textContent = `${lbI + 1} / ${lbLista.length}`;
      lb.querySelectorAll('.fbs-lb__arrow').forEach((b) => { b.hidden = lbLista.length < 2; });
      [lbI + 1, lbI - 1].forEach((j) => { const z = lbLista[(j + lbLista.length) % lbLista.length]; if (z) new Image().src = foto(z.u, 1280); });
    };
    const lbZamknij = () => {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.classList.remove('fbs-lb-open');
      lbWroc?.focus?.();
    };
    const lbOtworz = (id, i, skad) => {
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'fbs-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.hidden = true;
        lb.innerHTML = `
          <div class="fbs-lb__box">
            <div class="fbs-lb__media"><img class="fbs-lb__img" alt=""></div>
            <div class="fbs-lb__side">
              <div class="fbs__stars fbs-lb__stars" aria-hidden="true"></div>
              <h3 class="fbs-lb__title"></h3>
              <p class="fbs-lb__body"></p>
              <p class="fbs-lb__who"></p>
              <p class="fbs-lb__prod"></p>
              <p class="fbs-lb__n"></p>
            </div>
            <button type="button" class="fbs-lb__close" data-lb-close aria-label="${tekst(L.lClose)}"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>
            <button type="button" class="fbs-lb__arrow fbs-lb__arrow--prev" aria-label="${tekst(L.lPrev)}"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>
            <button type="button" class="fbs-lb__arrow fbs-lb__arrow--next" aria-label="${tekst(L.lNext)}"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.6"/></svg></button>
          </div>`;
        document.body.appendChild(lb);
        lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('[data-lb-close]')) lbZamknij(); });
        lb.querySelector('.fbs-lb__arrow--prev').addEventListener('click', () => lbPokaz(lbI - 1));
        lb.querySelector('.fbs-lb__arrow--next').addEventListener('click', () => lbPokaz(lbI + 1));
        document.addEventListener('keydown', (e) => {
          if (lb.hidden) return;
          if (e.key === 'Escape') lbZamknij();
          if (e.key === 'ArrowRight') lbPokaz(lbI + 1);
          if (e.key === 'ArrowLeft') lbPokaz(lbI - 1);
        });
        let tx = null;
        const m = lb.querySelector('.fbs-lb__media');
        m.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
        m.addEventListener('touchend', (e) => {
          if (tx === null) return;
          const dx = e.changedTouches[0].clientX - tx;
          tx = null;
          if (Math.abs(dx) > 40) lbPokaz(lbI + (dx < 0 ? 1 : -1));
        });
      }
      lbLista = zdjecia();
      const k = lbLista.findIndex((x) => x.r.id === id && x.i === i);
      lbWroc = skad;
      lbPokaz(Math.max(0, k));
      lb.hidden = false;
      document.documentElement.classList.add('fbs-lb-open');
      lb.querySelector('.fbs-lb__close').focus();
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-fbs-lb]');
      if (b) lbOtworz(b.dataset.fbsLb, Number(b.dataset.i) || 0, b);
    });

    // ---------- pisanie opinii ----------
    const panel = $('[data-fbs-form]');
    const otworzFormularz = () => {
      panel.hidden = false;
      // Judge.me przy pierwszym kliknięciu tylko buduje formularz (ukryty) — klikamy, aż będzie widoczny (maks. 3 razy)
      const t0 = Date.now();
      let proby = 0;
      const widoczny = () => (panel.querySelector('.jdgm-form-wrapper')?.offsetHeight || 0) > 0;
      const klik = () => {
        const link = panel.querySelector('.jdgm-write-rev-link');
        if (widoczny()) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          panel.querySelector('.jdgm-form-wrapper input, .jdgm-form-wrapper textarea')?.focus({ preventScroll: true });
          return;
        }
        if (link && window.jdgm && proby < 3) {
          proby++;
          link.click();
          setTimeout(klik, 500);
          return;
        }
        if (Date.now() - t0 < 8000 && proby < 3) setTimeout(klik, 150);
      };
      klik();
    };
    $('[data-fbs-shop]').addEventListener('click', otworzFormularz);
    $('[data-fbs-form-zu]').addEventListener('click', () => {
      panel.hidden = true;
      $('[data-fbs-shop]').focus();
    });
    $('[data-fbs-prod-select]').addEventListener('change', (e) => {
      if (e.target.value) location.href = `${e.target.value}#bewertung-schreiben`;
    });
    if (location.hash === '#schreiben') otworzFormularz();

    // ---------- start: metapole, potem wszystkie strony API ----------
    przyjmij($('[data-fbs-erste]')?.innerHTML || '', false);
    rysujRozklad();
    rysujChipy();
    rysuj();
    rysujZdjecia();

    const api = (typ, strona) =>
      `https://cdn.judge.me/reviews/all_reviews_js_based?url=${encodeURIComponent(L.shop)}&shop_domain=${encodeURIComponent(L.shop)}&platform=shopify&review_type=${typ}&sort_by=most_recent&page=${strona}`;
    const pobierz = async (typ, strona) => {
      try {
        const r = await fetch(api(typ, strona));
        if (!r.ok) return '';
        return (await r.json()).html || '';
      } catch (e) {
        return '';
      }
    };
    laduje = (async () => {
      const stron = Math.max(1, Math.ceil(ILE / NA_STRONE));
      const kolejka = [];
      for (let s = 1; s <= stron; s++) kolejka.push(s);
      // po 4 naraz, w kolejności stron (żeby „najnowsze” zostały najnowszymi)
      const wyniki = new Array(stron + 1);
      let gotowe = 1;
      const robot = async () => {
        while (kolejka.length) {
          const s = kolejka.shift();
          wyniki[s] = await pobierz('product-reviews', s);
          while (wyniki[gotowe] !== undefined) {
            przyjmij(wyniki[gotowe], false);
            gotowe++;
          }
        }
      };
      await Promise.all([robot(), robot(), robot(), robot()]);
      // opinie o sklepie (formularz „Shop bewerten”) — kolejne strony aż do pustej
      for (let s = 1; s <= 20; s++) {
        const h = await pobierz('shop-reviews', s);
        if (!przyjmij(h, true)) break;
      }
    })();
    laduje.then(() => {
      laduje = null;
      if (wszystkie.length) {
        rozklad = [5, 4, 3, 2, 1].map((s) => ({ s, n: wszystkie.filter((r) => r.rating === s).length }));
      }
      rysujRozklad();
      rysujChipy();
      rysuj(true);
      rysujZdjecia();
    });
  };

  const start = () => document.querySelectorAll('[data-fbs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
